import FilterItems, { IProcessedFilterItem } from 'helpers/filterItems';
import Client from 'api/release/HTTPClient';
import { AnnualBudgetUpdateRequest, IAnnualBudget, IGenericListRequest, IServerPage } from 'types';
import AnnualBudget from 'routes/AnnualBudget';

const annualBudgetsAPI = {
  list (request: IGenericListRequest): Promise<IServerPage<IAnnualBudget>> {
    return Client.post('/api/annualBudgets/', request);
  },

  getForAdvertiserPeriod (): Promise<typeof AnnualBudget> {
    return Client.get('/api/annualBudgets/getForClientPeriod');
  },

  get (id: number): Promise<typeof AnnualBudget> {
    return Client.get(`/api/annualBudgets/${id}`);
  },

  async getFilterItems (agencyId): Promise<IProcessedFilterItem[]> {
    const result = await Client.get(`/api/annualBudgets/filter-items?agencyKeycloakId=${agencyId}`);

    return FilterItems.getDataAndPostProcess(result);
  },

  save (id: number, data: AnnualBudgetUpdateRequest): Promise<typeof AnnualBudget> {
    if (!id) {
      return Client.post('/api/annualBudgets/new', data);
    }

    return Client.put(`/api/annualBudgets/${id}`, data);
  }
};

export default annualBudgetsAPI;
